import Vue from 'vue';
import { status } from './AxiosService';
import { caseStripRelation } from '@/utils/helper';
const { $gettext } = Vue.prototype;
export default {
  getTitle(message) {
    if (message.code === status.HTTP_NOT_FOUND) {
      return $gettext('Record not found');
    }
    if (message.code === status.HTTP_BAD_REQUEST) {
      return $gettext('Invalid request');
    }
    if (message.code === status.HTTP_CONFLICT) {
      return $gettext('Unable to delete item');
    }
    if (message.code === status.HTTP_INTERNAL_SERVER_ERROR) {
      return $gettext('Unable to process request');
    }
    if (message.action) {
      // convert camelCase and snake_case to normal case
      const action = message.action.split('_').join(' ').toLowerCase();
      return $gettext('Unable to ') + $gettext(action);
    }
    return null;
  },

  getContent(message) {
    if (message.code) {
      if (message.code === status.HTTP_NOT_FOUND) {
        return this.entityNotFound(message);
      }
      if (message.code === status.HTTP_BAD_REQUEST) {
        return this.badRequest(message);
      }
      if (message.code === status.HTTP_FORBIDDEN) {
        return this.forbidden(message);
      }
      if (message.code === status.HTTP_CONFLICT) {
        return this.conflict(message);
      }
      if (message.code === status.HTTP_INTERNAL_SERVER_ERROR) {
        return this.serverError(message);
      }
    }
    return message;
  },

  serverError(message) {
    if(message.error == 'The optimistic lock on an entity failed.'
        || message.error.indexOf('Deadlock found when trying to get lock; try restarting transaction') != -1
    ) {
      return $gettext('Server is busy at the moment. Please try again');
    }
    return message.error;
  },

  inlineError(message) {
    if (message.code !== status.HTTP_BAD_REQUEST) {
      return null;
    }

    if (!Array.isArray(message.error)) {
      return [{ msg: message.error, field: message.field }];
    }

    const errors = [];
    message.error.forEach((error) => {
      if (error.error === 'This form should not contain extra fields.') {
        errors.push({
          field: error.field,
          msg: `${$gettext(error.error)} ${error.value}`,
        });
      } else {
        errors.push({
          field: error.field,
          msg: $gettext(error.error),
        });
      }
    });
    return errors;
  },

  entityNotFound(message) {
    return `${$gettext(message.entity)} #${message.id} ${$gettext('does not exist or deleted')}`;
  },

  badRequest(message) {
    if (message.field && message.field === 'staff') {
      return `${$gettext(message.field)} #${message.value} ${$gettext(message.error)}`;
    }
    return `${$gettext(message.error)}`;
  },

  forbidden(message) {
    return $gettext(message.error);
  },
  
  conflict(message) {
    
    const relations = message.relations.split(',');
    const transformedRelation = [];
    relations.forEach(relation => {
      const caseStrippedRelation = caseStripRelation(relation);
      if(caseStrippedRelation != '') {
        transformedRelation.push($gettext(caseStrippedRelation));
      }
    });
    return $gettext('Please delete related') 
            + ' ' 
            + transformedRelation.join(', ') 
            + ' ' 
            + $gettext('of') 
            + ' ' 
            + $gettext(caseStripRelation(message.entity)) + ' ' + $gettext('first.');
  },
  
};
